import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Partenaire, PartenaireService } from 'src/app/core/services/partenaire.service';

@Component({
  selector: 'app-gestion-partenaire',
  templateUrl: './gestion-partenaire.component.html',
  styleUrls: ['./gestion-partenaire.component.scss']
})
export class GestionPartenaireComponent implements OnInit {

  formulaire!: FormGroup;
  modeEdition = false;
  partenaireId?: number;
  chargement = false;
  soumission = false;
  messageFlash: { type: 'success' | 'error', texte: string } | null = null;

  constructor(
    private fb: FormBuilder,
    private service: PartenaireService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.construireFormulaire();
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.modeEdition = true;
      this.partenaireId = +id;
      this.chargerPartenaire(+id);
    }
    // Réagir au changement de typeContrat pour les validations
    this.formulaire.get('typeContrat')?.valueChanges.subscribe(() => {
      this.mettreAJourValidations();
    });
  }

  construireFormulaire(): void {
    this.formulaire = this.fb.group({
      nomProprietaire:    ['', Validators.required],
      contactProprietaire:['', Validators.required],
      immatriculation:    ['', Validators.required],
      marque:             ['', Validators.required],
      modele:             ['', Validators.required],
      couleur:            [''],
      numeroChassis:      ['', Validators.required],
      typeContrat:        ['PAR_LIVRAISON', Validators.required],
      montantParLivraison:[null],
      montantMensuel:     [null],
      enService:          [true],
      disponible:         [true],
    });
    this.mettreAJourValidations();
  }

  mettreAJourValidations(): void {
    const contrat = this.formulaire.get('typeContrat')?.value;
    const ctrl1 = this.formulaire.get('montantParLivraison');
    const ctrl2 = this.formulaire.get('montantMensuel');
    ctrl1?.clearValidators();
    ctrl2?.clearValidators();
    if (contrat === 'PAR_LIVRAISON' || contrat === 'HYBRIDE') {
      ctrl1?.setValidators([Validators.required, Validators.min(0)]);
    }
    if (contrat === 'MENSUEL' || contrat === 'HYBRIDE') {
      ctrl2?.setValidators([Validators.required, Validators.min(0)]);
    }
    ctrl1?.updateValueAndValidity();
    ctrl2?.updateValueAndValidity();
  }

  chargerPartenaire(id: number): void {
    this.chargement = true;
    this.service.obtenirPartenaire(id).subscribe({
      next: (p) => {
        this.formulaire.patchValue({
          nomProprietaire: p.nomProprietaire,
          contactProprietaire: p.contactProprietaire,
          immatriculation: p.immatriculation,
          marque: p.marque,
          modele: p.modele,
          couleur: p.couleur || '',
          numeroChassis: p.numeroChassis,
          typeContrat: p.typeContrat,
          montantParLivraison: p.montantParLivraison || null,
          montantMensuel: p.montantMensuel || null,
          enService: p.enService,
          disponible: p.disponible,
        });
        this.mettreAJourValidations();
        this.chargement = false;
      },
      error: () => { this.flash('error', 'Impossible de charger le partenaire.'); this.chargement = false; }
    });
  }

  soumettre(): void {
    if (this.formulaire.invalid) { this.formulaire.markAllAsTouched(); return; }
    this.soumission = true;
    const data: Partial<Partenaire> = { ...this.formulaire.value, typeFlotte: 'PARTENAIRE' };
    const req = this.modeEdition && this.partenaireId
      ? this.service.modifierPartenaire(this.partenaireId, data)
      : this.service.creerPartenaire(data);

    req.subscribe({
      next: () => {
        this.soumission = false;
        this.router.navigate(['/partenaires/liste']);
      },
      error: () => { this.soumission = false; this.flash('error', 'Erreur lors de l\'enregistrement.'); }
    });
  }

  annuler(): void {
    this.router.navigate(['/partenaires/liste']);
  }

  estInvalide(champ: string): boolean {
    const ctrl = this.formulaire.get(champ);
    return !!(ctrl && ctrl.invalid && (ctrl.dirty || ctrl.touched));
  }

  get typeContrat(): string { return this.formulaire.get('typeContrat')?.value || ''; }

  flash(type: 'success' | 'error', texte: string): void {
    this.messageFlash = { type, texte };
    setTimeout(() => this.messageFlash = null, 4000);
  }
}
